<div class="container">
  <div class="top">
    <button
      mat-icon-button
      class="close-button"
      (click)="onCloseButtonClick()"
      [disabled]="saving"
    >
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>
  <mat-form-field
    class="version-name-field subscripts"
    color="accent"
    matTooltip="Give this version a name"
    appearance="outline"
    matTooltipPosition="above"
    matTooltipShowDelay="1000"
  >
    <input
      #nameInput
      class="version-name-input"
      [formControl]="nameControl"
      maxlength="50"
      matInput
      placeholder="Version Name"
    />
  </mat-form-field>
  <div class="bottom">
    <button
      class="save-button"
      mat-flat-button
      color="accent"
      (click)="onSaveButtonClick()"
      [disabled]="saving"
    >
      <span *ngIf="!saving">Save</span>
      <merri-loading-spinner
        [color]="primary"
        [loading]="saving"
        *ngIf="saving"
      ></merri-loading-spinner>
    </button>
    <div
      class="error"
      *ngIf="error"
    >
      {{ error }}
    </div>
  </div>
</div>
